import { api } from '../api';

export interface LockerReservation {
  id: string;
  equipmentId: string;
  equipmentName: string;
  userId: string;
  userName: string;
  durationHours: number;
  startDate: string;
  startTime: string;
  endDate: string;
  endTime: string;
  status: 'PENDING' | 'CONFIRMED' | 'CANCELLED' | 'COMPLETED';
  tenantId: string;
  tenantName: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateLockerReservationData {
  equipmentId: string;
  userId: string;
  durationHours: number;
  startDate: string;
  startTime: string;
  tenantId: string;
}

export interface UpdateLockerReservationData extends Partial<CreateLockerReservationData> {}

export const lockerReservationService = {
  list: async () => {
    const response = await api.get<LockerReservation[]>('/locker-reservations');
    return response.data;
  },

  getById: async (id: string) => {
    const response = await api.get<LockerReservation>(`/locker-reservations/${id}`);
    return response.data;
  },

  create: async (data: CreateLockerReservationData) => {
    const response = await api.post<LockerReservation>('/locker-reservations', data);
    return response.data;
  },

  update: async (id: string, data: UpdateLockerReservationData) => {
    const response = await api.put<LockerReservation>(`/locker-reservations/${id}`, data);
    return response.data;
  },

  delete: async (id: string) => {
    await api.delete(`/locker-reservations/${id}`);
  },

  getByEquipment: async (equipmentId: string) => {
    const response = await api.get<LockerReservation[]>(`/locker-reservations/equipment/${equipmentId}`);
    return response.data;
  },

  getByLocker: async (lockerId: string) => {
    const response = await api.get<LockerReservation[]>(`/locker-reservations/locker/${lockerId}`);
    return response.data;
  },

  getByUser: async (userId: string) => {
    const response = await api.get<LockerReservation[]>(`/locker-reservations/user/${userId}`);
    return response.data;
  },

  checkAvailability: async (equipmentId: string, startDate: string, startTime: string, durationHours: number) => {
    const response = await api.get(`/locker-reservations/availability`, {
      params: {
        equipmentId,
        startDate,
        startTime,
        durationHours
      }
    });
    return response.data;
  },
}; 